import React, { useState, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  Polygon,
  InfoWindow,
} from "@react-google-maps/api";
import { domain, googleMapsApiKey } from "../../Urls/Services/Api_urls";

const MapRender = (props) => {
  const [shouldSendRequest, setShouldSendRequest] = useState(true);
  console.log("desde mapRender");
  let polygons = props.data;
  console.log(polygons);
  const [path, setPath] = useState([]);
  const [center, setCenter] = useState({
    lat: 3.3750139010000453,
    lng: -76.564036637999948,
  });
  const [infoWindowPositions, setInfoWindowPositions] = useState(
    Array(polygons.length).fill(null)
  );
  const [infoWindowContents, setInfoWindowContents] = useState(
    Array(polygons.length).fill(null)
  );

  const handlePolygonClick = (index, event, data) => {
    // Mostrar el InfoWindow correspondiente cuando se hace clic en un polígono
    const newPositions = [...infoWindowPositions];
    if (newPositions[index] === undefined) {
      newPositions[index] = event.latLng;
    } else {
      newPositions[index] = undefined; // Cierra el InfoWindow si ya estaba abierto
    }
    setInfoWindowPositions(newPositions);

    const newContents = [...infoWindowContents];
    newContents[index] = data.info; // Asigna la información del polígono que deseas mostrar
    setInfoWindowContents(newContents);
  };

    useEffect(() => {

      for (let index = 0; index < polygons.length; index++) {
        const newCenter = polygons[index].polygon[0];
      
        setCenter(newCenter);
      }
 
}, []);

  if (shouldSendRequest) {
    return (
      <>
        <LoadScript googleMapsApiKey={googleMapsApiKey}>
          <GoogleMap
            mapContainerStyle={{ width: props.width, height: props.height }}  
            zoom={props.zoom}
            center={center}
          >
            {polygons.map((data, index) => (
              <React.Fragment key={data.id}>
                <Polygon
                
                  paths={data.poligono}
                  options={{
                    fillColor: "#771EEB",
                    fillOpacity: 0.5,
                    strokeColor: "#771EEB",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                  }}
                  onClick={(event) => handlePolygonClick(index, event, data)}
                />
                {infoWindowPositions[index] && (
                  <InfoWindow
                    position={infoWindowPositions[index]}
                    onCloseClick={() => handlePolygonClick(index, null, data)} // Cierra el InfoWindow
                  >
                    <div>
                      <p>{data.cdo}</p>
                      <p>{data.city_name}</p>
                      
                      <a href={`/PolygonEdit/${data.id}`} style={{borderRadius: "1rem", height: "20px", display: "flex", justifyContent: "center", alignItems: "center", border: "none", backgroundColor: "#3b82f6", color: "white", width: "100%", textDecoration: "none"}}>Ver</a>
                      <div>{infoWindowContents[index]}</div>
                    </div>
                  </InfoWindow>
                )}
              </React.Fragment>
            ))}
          </GoogleMap>
        </LoadScript>
      </>
    );
  }
};

export default MapRender;
